import Button from '@mui/material/Button';
import {withStyles} from '@mui/styles'

export const ButtonMin = withStyles({
	root: {
		minWidth: 0,
		minHeight: 0,
	},
})(Button);